import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '附件',
    type: 'DES_OTH',
}
